<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir">
            <div class="p-fluid p-formgrid grid mb-3">
                <div *ngIf="messagemVisivel" class="col-12">
                    <p-messages
                        [(value)]="messages"
                        [enableService]="false"
                        [closable]="true"
                    ></p-messages>
                </div>
                <div class="field col-4 md:col-4">
                    <label htmlFor="psp">PSP</label>
                    <p-dropdown
                        [options]="listaPsps"
                        optionLabel="nome"
                        [filter]="true"
                        emptyFilterMessage="Nenhum registro"
                        placeholder="Selecione"
                        name="psp"
                        ngModel
                        (onChange)="selecionarPsp()"
                        [(ngModel)]="pspSelecionado"
                    ></p-dropdown>
                </div>
            </div>
            <div class="flex justify-content-center" *ngIf="loadingForm">
                <p-progressSpinner></p-progressSpinner>
            </div>
            <form *ngIf="formulario && !loadingForm" [formGroup]="formulario">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div class="field col-4 md:col-4" *ngFor="let campo of metadadadosPsp">
                            <label>{{ campo.chave }}</label>

                            <input
                                [formControlName]="campo.chave"
                                [id]="campo.chave"
                                type="text"
                                pInputText
                                [placeholder]="'Informe ' + campo.chave"
                            />
                        </div>
                    </div>
                </div>
            </form>

            <div class="p-fluid p-formgrid grid mb-3" *ngIf="pspSelecionado">
                <div class="field col-4 md:col-4">
                    <label>Tipo de Chave Pix</label>
                    <p-dropdown
                        [options]="tiposChavePix"
                        placeholder="Selecione"
                        ngModel
                        name="tipoChavePix"
                        [(ngModel)]="tipoChavePixSelecionada"
                    ></p-dropdown>
                </div>
            </div>

            <div class="p-fluid p-formgrid grid justify-content-between mt-2">
                <div class="col-12 md:col-4">
                    <button
                        *ngIf="!progressoRequisicao; else exibirBotaoFalso"
                        type="submit"
                        pButton
                        icon="pi pi-check"
                        label="Salvar"
                        class="p-button-outlined p-button-success md:w-9rem"
                        (click)="salvar()"
                        [disabled]="!pspSelecionado"
                    ></button>
                    <ng-template #exibirBotaoFalso>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-spin pi-spinner"
                            label="Salvar"
                            class="p-button-outlined p-button-success md:w-9rem"
                            disabled
                        ></button>
                    </ng-template>
                </div>
                <div class="col-12 md:col-4 flex justify-content-end">
                    <button
                        type="button"
                        pButton
                        icon="pi pi-arrow-left"
                        label="Voltar"
                        class="p-button-outlined md:w-9rem"
                        routerLink="/apps/configuracao-pix"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</div>
